import { useState } from "react";
import styles from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faPhone, faUser } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faLinkedin, faSquareWhatsapp, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";

const ContactUs = () => {
  const [formData, setFormData] = useState({});
  const [isError, setError] = useState({});

  const onChangeInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError({ ...isError, [e.target.name]: "" });
  };
  return (
    <div className={styles.contactDiv}>
      <div className={`main-container`} id="contact">
        <div className={`container-content`}>
          <div className={styles.textCol}>
            <p className={styles.bannerTitle}>How Can We Help?</p>
          </div>
          <div className={styles.cardsSec}>
            <div className={styles.cardOne}>
              <div className={styles.cardLeft}>
                <p>
                  Please feel welcome to contact us
                  with any enquiry.
                </p>
                <form className={styles.contactForm}>
                  <div className={styles.formInput}>
                    <FontAwesomeIcon icon={faUser} className={styles.icon} />
                    <input
                      name="name"
                      id="name"
                      type="text"
                      value={formData.name || ""}
                      placeholder="Name"
                      onChange={(e) => onChangeInput(e)}
                      className={styles.contactInput}
                    />
                    {isError.name && <p>{isError.name}</p>}
                  </div>
                  <div className={styles.formInput}>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className={styles.icon}
                    />
                    <input
                      name="email"
                      id="email"
                      type="email"
                      value={formData.email || ""}
                      placeholder="Email Address"
                      onChange={(e) => onChangeInput(e)}
                      className={styles.contactInput}
                    />
                    {isError.email && <p>{isError.email}</p>}
                  </div>
                  <div className={styles.formInput}>
                    <FontAwesomeIcon icon={faFile} className={styles.icon} />
                    <input
                      name="subject"
                      id="subject"
                      type="subject"
                      value={formData.subject || ""}
                      placeholder="Subject"
                      onChange={(e) => onChangeInput(e)}
                      className={styles.contactInput}
                    />
                    {isError.subject && <p>{isError.subject}</p>}
                  </div>
                  <div className={styles.formInput}>
                    <FontAwesomeIcon
                      icon={faMessage}
                      className={styles.areaIcon}
                    />
                    <textarea
                      name="message"
                      id="message"
                      type="text"
                      rows={10}
                      value={formData.message || ""}
                      placeholder="Message"
                      onChange={(e) => onChangeInput(e)}
                      className={styles.contactAreaInput}
                    />
                    {isError.message && <p>{isError.message}</p>}
                  </div>
                  <button className={styles.submitBtn} type="button">
                    Submit
                  </button>
                </form>
              </div>
              <div className={styles.cardRight}>
                <div className={styles.detailsCard}>
                  <p className={styles.contactTitle}>Quick Contacts</p>
                  <p className={styles.contactText}>
                    Please feel free to contact our friendly staff with any
                    enquiry you may have. We are here to assist you with all
                    your questions and provide the support you need. Whether
                    it’s a simple clarification or detailed information, don’t
                    hesitate to reach out. Your satisfaction is our top
                    priority, and we look forward to helping you!
                  </p>
                  <div className={styles.detailsSec}>
                    {/* <p>
                      <FontAwesomeIcon icon={faPhone} />{" "}
                      +94(75) 678 0969
                    </p> */}
                    <p>
                      <FontAwesomeIcon icon={faPhone} />{" "}
                      +94(77) 976 9012
                    </p>
                    <p>
                      <FontAwesomeIcon icon={faSquareWhatsapp} />{" "}
                       +94(77) 976 9012
                    </p>
                  </div>
                  <div className={styles.socialMedia}>
                    <a href="https://web.facebook.com/profile.php?id=61584655946235" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                      <FontAwesomeIcon icon={faFacebook} className={styles.socialIcon} />
                    </a>
                    <a href="https://www.tiktok.com/@studyhubplus" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                      <FontAwesomeIcon icon={faTiktok} className={styles.socialIcon} />
                    </a>
                      <a href="https://www.youtube.com/@studyhub-b7o" target="_blank" rel="noopener noreferrer" style={{ color: '#FFFFFF' }}>
                      <FontAwesomeIcon icon={faYoutube} className={styles.socialIcon} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;